// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ControlMessage, ControlMessageT, verifyControlMessage } from "../control/control-message";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

export class UiCmd implements flatbuffers.IUnpackableObject<UiCmdT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UiCmd {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUiCmd(bb: flatbuffers.ByteBuffer, obj?: UiCmd): UiCmd {
    return (obj || new UiCmd()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUiCmd(bb: flatbuffers.ByteBuffer, obj?: UiCmd): UiCmd {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UiCmd()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  msg(obj?: ControlMessage): ControlMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new ControlMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  liftId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  timestamp(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startUiCmd(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addMsg(builder: flatbuffers.Builder, msgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, msgOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +false);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, channelIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, liftIdOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, bankIdOffset, 0);
  }

  static addTimestamp(builder: flatbuffers.Builder, timestamp: bigint) {
    builder.addFieldInt64(5, timestamp, 0n);
  }

  static endUiCmd(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // msg
    builder.requiredField(offset, 8); // channel_id
    builder.requiredField(offset, 12); // bank_id
    return offset;
  }

  static finishUiCmdBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedUiCmdBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, undefined, true);
  }

  unpack(): UiCmdT {
    return new UiCmdT(
      this.msg() !== null ? this.msg()!.unpack() : null,
      this.active(),
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.timestamp(),
    );
  }

  unpackTo(_o: UiCmdT): void {
    _o.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    _o.active = this.active();
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.timestamp = this.timestamp();
  }

  unpackFields(...fields: string[]): UiCmdT {
    const t = new UiCmdT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("msg")) {
      t.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("timestamp")) {
      t.timestamp = this.timestamp();
    }
    return t;
  }
}

export class UiCmdT implements flatbuffers.IGeneratedObject {
  constructor(
    public msg: ControlMessageT | null = null,
    public active: boolean = false,
    public channelId: UuidT | null = null,
    public liftId: UuidT | null = null,
    public bankId: UuidT | null = null,
    public timestamp: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.msg === null || this.msg === undefined) {
      throw new Error('Required field "msg" is not set');
    }
    if (this.channelId === null || this.channelId === undefined) {
      throw new Error('Required field "channel_id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    const msg = this.msg !== null ? this.msg!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;

    UiCmd.startUiCmd(builder);
    UiCmd.addMsg(builder, msg);
    UiCmd.addActive(builder, this.active);
    UiCmd.addChannelId(builder, channelId);
    UiCmd.addLiftId(builder, liftId);
    UiCmd.addBankId(builder, bankId);
    UiCmd.addTimestamp(builder, this.timestamp);

    return UiCmd.endUiCmd(builder);
  }

  clone(): UiCmdT {
    const obj = new UiCmdT();
    obj.msg = this.msg !== null ? this.msg!.clone() : null;
    obj.active = this.active;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.timestamp = this.timestamp;
    return obj;
  }

  equals(other: UiCmdT): boolean {
    if (this.msg !== null && other.msg !== null) {
      if (!this.msg!.equals(other.msg!)) return false;
    } else if (this.msg !== other.msg) return false;
    if (this.active !== other.active) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.timestamp !== other.timestamp) return false;
    return true;
  }
}

export function verifyUiCmd(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyControlMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "msg");
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "channel_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "bank_id");
    verifier.checkScalarField(tablePos, 14, 8);
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsUiCmd(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyUiCmd(verifier, tablePos);
}
